<template>
  <div>
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
    <div v-else-if="is_no_records == 1">
      <GlobalEmptyRecord RouteName="CustomerCreate">
        <template slot="title">
          <h2>All Your Customers at one place!!!</h2>
        </template>
        <template slot="content">
          <span style="color: gray">Personalize your business Contacts</span>
        </template>
        <template slot="page">New Customer</template>
        <template slot="importbutton">
          <router-link :to="{ name: 'CustomerImport' }">
            <b-button
              variant="light"
              size="sm"
              class="mb-xs mr-xs"
              title="Import Customers"
            >
              <span class="fa fa-upload"></span>
            </b-button>
          </router-link>
        </template>
      </GlobalEmptyRecord>
    </div>
    <div class="start-page" v-else style="margin-top: -10px !important">
      <template v-if="CheckedCount == 0">
        <b-row class="px-pad border-bottom" style="height: 42px">
          <b-col cols="8" class="px-0">
            <b-dropdown
              variant="link"
              class="index-filter-heading"
              toggle-class="text-decoration-none"
              size="sm"
              dropdown
              :text="filter_name"
            >
              <div class="dropdownitem-list">
                <b-dropdown-item
                  :class="{ filter_dropdown: true }"
                  :to="{
                    name: 'Customer',
                    query: {
                      page: 1,
                      show: 10,
                      search: '',
                      status: status,
                      sort: sort,
                      label: label,
                      status: item.status_id,
                    },
                  }"
                  v-for="item in filter_list"
                  :key="item.status_id"
                  v-if="item.status_name != filter_name"
                  >{{ item.status_name }}</b-dropdown-item
                >
              </div>
              <b-dropdown-divider />
              <router-link
                class="event-link dropdown-item"
                :to="{
                  name: 'FilterCreate',
                  params: {
                    title: 'Customer',
                    module: 'customer',
                    call: 'fetchCustomerFilterDetails',
                    route: 'customer',
                  },
                }"
                >Add Custom Filter</router-link
              >
            </b-dropdown>
            <!-- edit button for custom filter dropdown -->
            <router-link
              class="event-link"
              v-if="status >= 100"
              :to="{
                name: 'FilterUpdate',
                params: {
                  id: getPresentValue(filter_list, 'status_name', filter_name),
                  title: 'Customer',
                  module: 'customer',
                  call: 'fetchCustomerFilterDetails',
                  route: 'customer',
                },
              }"
            >
              <b-button
                size="xs"
                style="position: relative; bottom: 4px"
                variant="light"
              >
                <i class="la la-edit la-lg"></i>
              </b-button>
            </router-link>
          </b-col>

          <b-col cols="4" class="text-right px-0">
            <router-link
              :to="{ name: 'CustomerCreate' }"
              v-if="RoutePermission(false, '', '', 'customer', 'create')"
            >
              <b-button variant="primary" size="sm" class="mr-2"
                >New Customer</b-button
              >
            </router-link>
            <b-button
              variant="light"
              size="sm"
              class="mr-2"
              @click="getrefreshList()"
            >
              <i class="la la-refresh la-lg"></i
            ></b-button>
            <b-dropdown variant="light" size="sm" class="no-caret-dropdown">
              <template slot="button-content">
                <i class="la la-navicon la-lg"></i>
              </template>
              <b-dropdown-item>
                <router-link
                  :to="{ name: 'CustomerImport' }"
                  class="text-decoration-none text-dark"
                  v-if="RoutePermission(false, '', '', 'customer', 'create')"
                >
                  <span class="no_caret_import la la-upload mr-3"></span>Import
                  Customers
                </router-link>
              </b-dropdown-item>
              <template
                v-if="RoutePermission(false, '', '', 'settings', 'export')"
              >
                <b-dropdown-item @click="exportModal()">
                  <span class="no_caret_import la la-download mr-3"></span
                  >Export Customers
                </b-dropdown-item>
              </template>
              <b-dropdown-divider></b-dropdown-divider>
              <p class="fw-semi-bold theme-text-color ml-3">Add Columns</p>
              <div class="dropdownitem-block">
                <li class="ml-3">
                  <b-form-checkbox
                    name="gst_type_name"
                    v-model="gst_type_name"
                    value="1"
                    >GST Treatment</b-form-checkbox
                  >
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="cus_gst_no"
                    v-model="cus_gst_no"
                    value="2"
                    >GST Number</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="term_name"
                    v-model="term_name"
                    value="3"
                    >Payment Terms</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="currency_name"
                    v-model="currency_name"
                    value="4"
                    >Currency</b-form-checkbox
                  >
                </li>

                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="place_of_supply"
                    v-model="place_of_supply"
                    value="5"
                    >Place of Supply</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="cus_legacy_id"
                    v-model="cus_legacy_id"
                    value="6"
                    >Customer ID</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2">
                  <b-form-checkbox
                    name="created_at"
                    v-model="created_at"
                    value="7"
                    >Created Time</b-form-checkbox
                  >
                </li>
                <li class="ml-3 pt-2 pb-2">
                  <b-form-checkbox
                    name="updated_at"
                    v-model="updated_at"
                    value="8"
                    >Updated Time</b-form-checkbox
                  >
                </li>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col cols="12" class="px-0">
          <!-- custom filter dropdown -->

          <!--  row for bulk delete option and acitve and inactive if atleast one checkbox is selected in the table -->
          <b-row
            style="height: 42px"
            class="px-pad border-bottom"
            v-if="CheckedCount > 0"
          >
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
              <b-button
                size="sm"
                v-b-modal.delete
                @click="modalPage = 'delete'"
                variant="light"
                class="text-left mr-2"
                :disabled="
                  !RoutePermission(false, '', 'invoice', 'customer', 'delete')
                "
              >
                <i
                  class="glyphicon glyphicon-trash"
                  v-b-tooltip="
                    !RoutePermission(false, '', 'invoice', 'customer', 'delete')
                      ? ' You do not have permission to perform this operation. Please contact your Administrator. '
                      : ''
                  "
                ></i>
              </b-button>
              <b-button
                @click="(statusPage = 'active'), (modalPage = 'status')"
                v-b-modal.statusPage
                variant="light"
                size="sm"
                class="text-left mr-2"
                :disabled="
                  !RoutePermission(false, '', '', 'customer', 'update')
                "
              >
                <span
                  v-b-tooltip="
                    !RoutePermission(false, '', 'invoice', 'customer', 'update')
                      ? ' You do not have permission to perform this operation. Please contact your Administrator. '
                      : ''
                  "
                  >Active</span
                >
              </b-button>
              <b-button
                @click="(statusPage = 'inactive'), (modalPage = 'status')"
                v-b-modal.statusPage
                variant="light"
                size="sm"
                class="text-left"
                :disabled="
                  !RoutePermission(false, '', '', 'customer', 'update')
                "
              >
                <span
                  v-b-tooltip="
                    !RoutePermission(false, '', 'invoice', 'customer', 'update')
                      ? ' You do not have permission to perform this operation. Please contact your Administrator. '
                      : ''
                  "
                  >Inactive</span
                >
              </b-button>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="6" xs="6" cols="6" class="px-pad">
              <i
                v-on:click="
                  checkAll({
                    target: {
                      checked: false,
                    },
                  }),
                    (CheckedCount = 0),
                    (checkboxes1[0] = false)
                "
                class="la la-times-circle-o la-lg cursor_pointer float-right mar-top-close"
              ></i>
            </b-col>
          </b-row>
          <!-- search critertail alert -->
          <b-alert
            class="alert-transparent alert-shade mx-mar mt-3"
            :show="this.$route.params.search == '' ? false : true"
          >
            <router-link
              class="text-dark float-right"
              :to="{
                name: 'Customer',
                query: {
                  page: page,
                  show: count,
                  search: '',
                  sort: sort,
                  label: label,
                },
              }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </router-link>
            <p>
              <span class="fw-semi-bold"
                >Customer Name / Customer ID / Company name / Phone No / GST No
                :</span
              >
              {{ this.$route.query.search }}
            </p>
          </b-alert>

          <div
            :class="
              this.$route.params.search == ''
                ? 'table-responsive'
                : 'table_search'
            "
            id="scrollCol"
          >
            <table class="table table-hover index-table">
              <thead>
                <tr>
                  <th style="width: 54px !important">
                    <div class="abc-checkbox index-checkbox text-left">
                      <input
                        type="checkbox"
                        id="checkboxall"
                        v-model="checkboxes1[0]"
                        @change="checkAll($event)"
                      />
                      <label for="checkboxall" />
                    </div>
                  </th>
                  <th style="min-width: 250px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'cus_name',
                          custom: custom,
                        },
                      }"
                    >
                      Customer
                      <small class="text-muted" v-if="label == 'cus_name'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th
                    style="min-width: 150px !important"
                    v-if="cus_legacy_id == 6"
                  >
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'cus_legacy_id',
                          custom: custom,
                        },
                      }"
                    >
                      Customer ID
                      <small class="text-muted" v-if="label == 'cus_legacy_id'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width: 130px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'cus_ph_no_1',
                          custom: custom,
                        },
                      }"
                    >
                      Phone No.
                      <small class="text-muted" v-if="label == 'cus_ph_no_1'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width: 180px !important" class="text-dark">
                    Email
                  </th>
                  <th
                    style="min-width: 210px !important"
                    v-if="gst_type_name == 1"
                  >
                    GST Treatment
                  </th>
                  <th
                    style="min-width: 145px !important"
                    v-if="cus_gst_no == 2"
                  >
                    GST No
                  </th>
                  <th style="min-width: 140px !important" v-if="term_name == 3">
                    Payment Terms
                  </th>
                  <th
                    style="min-width: 180px !important"
                    v-if="currency_name == 4"
                  >
                    Currency
                  </th>
                  <th
                    style="min-width: 200px !important"
                    v-if="place_of_supply == 5"
                  >
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'place_of_supply',
                          custom: custom,
                        },
                      }"
                    >
                      Place of Supply
                      <small
                        class="text-muted"
                        v-if="label == 'place_of_supply'"
                      >
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <!-- <th style="min-width:150px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{ name : 'Customer',query: {page: page,show: show,search:search_criteria,status:status,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'place_of_supply',custom:custom} }"
                  >
                    Address
                    <small class="text-muted" v-if="label == 'place_of_supply'">
                      <i
                        :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                        style="font-weight:thinner;"
                      ></i>
                    </small>
                  </router-link>
                </th>-->
                  <th
                    class="text-dark text-right"
                    style="min-width: 140px !important"
                  >
                    Due
                  </th>
                  <th
                    class="text-dark text-right"
                    style="min-width: 140px !important"
                  >
                    <span v-b-tooltip title="Unused Credits">Credits</span>
                  </th>
                  <th style="min-width: 300px !important" v-if="created_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'created_at',
                          custom: custom,
                        },
                      }"
                    >
                      Created Time
                      <small class="text-muted" v-if="label == 'created_at'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="min-width: 300px !important" v-if="updated_at">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page,
                          show: show,
                          search: search_criteria,
                          status: status,
                          sort: sort == 'asc' ? 'desc' : 'asc',
                          label: 'updated_at',
                          custom: custom,
                        },
                      }"
                    >
                      Updated Time
                      <small class="text-muted" v-if="label == 'updated_at'">
                        <i
                          :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                          style="font-weight: thinner"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width: 30px !important" class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <template v-if="lists.length == 0">
                  <tr>
                    <td colspan="9" class="text-center">No data to display</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(list, index) in lists" :key="list.cus_id">
                    <td>
                      <div class="abc-checkbox index-checkbox text-left">
                        <input
                          type="checkbox"
                          v-model="checkboxes1[index + 1]"
                          :id="'checkbox' + (index + 1)"
                          :true-value="list.cus_id"
                          :value="list.cus_id"
                          @change="
                            (event) =>
                              changeCheck(event, 'checkboxes1', index + 1)
                          "
                        />
                        <label :for="'checkbox' + (index + 1)" />
                      </div>
                    </td>
                    <td
                      style="max-width: 250px !important"
                      v-if="
                        RoutePermission(
                          false,
                          '',
                          'invoice',
                          'customer',
                          'index'
                        )
                      "
                    >
                      <router-link
                        class="event-link theme-text-color"
                        :to="{
                          name: 'CustomerView',
                          params: { id: list.cus_id },
                        }"
                      >
                        <span class="text theme-text-color btn-link">{{
                          list.cus_name
                        }}</span>
                      </router-link>
                    </td>
                    <td v-else>
                      <span class="text theme-text-color btn-link">{{
                        list.cus_name
                      }}</span>
                    </td>
                    <td v-if="cus_legacy_id == 6">{{ list.cus_legacy_id }}</td>
                    <td>{{ list.cus_ph_no_1 }}</td>
                    <td style="width: 180px !important">
                      <span class="text">{{ list.cus_mail }}</span>
                    </td>
                    <td v-if="gst_type_name == 1">{{ list.gst_type_name }}</td>
                    <td v-if="cus_gst_no == 2">{{ list.cus_gst_no }}</td>
                    <td v-if="term_name == 3">{{ list.term_name }}</td>
                    <td v-if="currency_name == 4">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_name"
                        )
                      }}
                    </td>

                    <td v-if="place_of_supply == 5">
                      {{
                        getDetails(
                          $AppDetails.state_details,
                          list.place_of_supply,
                          "state_name"
                        )
                      }}
                    </td>
                    <!-- <td style="width:120px !important">
                    <span
                      class="text"
                    >{{ getDetails($AppDetails.state_details,list.cus_state,'state_name')+' '+getDetails($AppDetails.country_details,list.cus_country,'country_name') }}</span>
                  </td>-->

                    <td class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                        " " +
                        parseFloat(list.cus_due).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.cus_currency,
                          "currency_symbol"
                        ) +
                        " " +
                        parseFloat(list.cus_unused_credits).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )
                      }}
                    </td>
                    <td v-if="created_at">
                      <span class="text">
                        {{ displayDateTime(list.created_at) }}
                      </span>
                    </td>
                    <td v-if="updated_at">
                      <span class="text">
                        {{ displayDateTime(list.updated_at) }}
                      </span>
                    </td>
                    <td class="text-right" style="width: 30px !important">
                      <router-link
                        v-if="
                          RoutePermission(
                            false,
                            '',
                            'invoice',
                            'customer',
                            'update'
                          )
                        "
                        class="event-link theme-text-color text-decoration-none"
                        :to="{
                          name: 'CustomerUpdate',
                          params: { id: list.cus_id },
                          query: { page_from: 'index' },
                        }"
                      >
                        <i
                          class="la la-edit la-lg theme-text-color table-hover-visible"
                        ></i>
                      </router-link>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="lists.length > 0"
        style="width: 100%; position: absolute; border-top: 1px solid #e0e0e0"
        class="px-pad"
      >
        <b-col xl="5" md="6" lg="6" sm="8" cols="8" class="mt-2 pt-1 px-0">
          <nav class="float-left">
            <p>
              Showing {{ total_count != 0 ? (page - 1) * count + 1 : 0 }} to
              {{ (page - 1) * show + lists.length }} of
              {{ total_count }} entries
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  size="xs"
                  :show="false"
                  :text="count"
                  left
                >
                  <router-link
                    :to="{
                      name: 'Customer',
                      query: {
                        page: 1,
                        show: 10,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 10"
                      >10</b-dropdown-item-button
                    >
                  </router-link>
                  <router-link
                    :to="{
                      name: 'Customer',
                      query: {
                        page: 1,
                        show: 25,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 25"
                      >25</b-dropdown-item-button
                    >
                  </router-link>
                  <router-link
                    :to="{
                      name: 'Customer',
                      query: {
                        page: 1,
                        show: 50,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    class="text-decoration-none"
                  >
                    <b-dropdown-item-button class="page-link" v-if="count != 50"
                      >50</b-dropdown-item-button
                    >
                  </router-link>
                </b-dropdown>
              </span>
              rows per page
            </p>
          </nav>
        </b-col>
        <b-col
          xl="2"
          md="2"
          lg="2"
          sm="4"
          cols="4"
          style="text-align: center"
          class="mt-2 pt-1 px-0"
        >
          <div v-if="arrow">
            <a @click="left('#scrollCol')" class="mr-2">
              <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
            </a>
            <a @click="right('#scrollCol')">
              <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

              <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
            </a>
          </div>
        </b-col>
        <b-col
          xl="5"
          md="4"
          lg="4"
          sm="12"
          class="mt-2 pt-1 px-0 d-md-block d-none"
        >
          <template v-if="total_count > show">
            <nav class="float-right">
              <ul class="pagination">
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page - 1,
                          show: count,
                          search: search_criteria,
                          status: status,
                          sort: sort,
                          label: label,
                          custom: custom,
                        },
                      }"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'Customer',
                      query: {
                        page: 1,
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >First</router-link
                  >
                </li>
                <li class="page-item">
                  <template v-if="page != 1">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page - 1,
                          show: count,
                          search: search_criteria,
                          status: status,
                          sort: sort,
                          label: label,
                          custom: custom,
                        },
                      }"
                      >Previous</router-link
                    >
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Previous</a>
                  </template>
                </li>
                <li class="page-item">
                  <template v-if="total_count > page * count">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page + 1,
                          show: count,
                          search: search_criteria,
                          status: status,
                          sort: sort,
                          label: label,
                          custom: custom,
                        },
                      }"
                      >Next</router-link
                    >
                  </template>
                  <template v-else>
                    <a href="#" class="page-link">Next</a>
                  </template>
                </li>
                <li class="page-item">
                  <router-link
                    class="page-link"
                    :to="{
                      name: 'Customer',
                      query: {
                        page: Math.ceil(total_count / count),
                        show: count,
                        search: search_criteria,
                        status: status,
                        sort: sort,
                        label: label,
                        custom: custom,
                      },
                    }"
                    >Last</router-link
                  >
                </li>
                <li class="page-item">
                  <template v-if="total_count > page * count">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Customer',
                        query: {
                          page: page + 1,
                          show: count,
                          search: search_criteria,
                          status: status,
                          sort: sort,
                          label: label,
                          custom: custom,
                        },
                      }"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </template>
                </li>
              </ul>
            </nav>
          </template>
        </b-col>
      </b-row>
      <!-- you can add element-ui's tooltip -->

      <!--  -->

      <b-modal
        id="delete"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
        title="Bulk Delete"
        @ok="handledelete"
        :ok-disabled="submitted"
      >
        <p>Are you sure you want to delete this customers ?</p>
      </b-modal>
      <b-modal
        id="statusPage"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
        title="Status"
        @ok="handledelete"
        :ok-disabled="submitted"
      >
        <p>
          Are you sure you want to {{ statusPage }} the selected customers ?
        </p>
      </b-modal>
      <LogRecord :message="logrecords"></LogRecord>
      <GlobalExportModal
        v-if="export_modal"
        :data="export_data"
        :columns="export_xl"
        :file_name="'Customers'"
        @downloaded="export_modal = false"
      />

      <!-- <b-form-group>
        <b-form-checkbox-group v-model="selected" :options="cusindex" name="cusindex" stacked></b-form-checkbox-group>
    </b-form-group>-->
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
import $ from "jquery";
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import RecordNotFound from "@/pages/Error/RecordNotFound";
function getPageCustomers(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  const search = routeTo.query.search || "";
  const status =
    routeTo.query.status || store.state.customer.index_status || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  const custom = routeTo.query.custom || "";
  store
    .dispatch("customer/fetchLists", {
      page: currentPage,
      show: show,
      search: search,
      status: status,
      sort: sort,
      label: label,
      custom: custom,
    })
    .then((response) => {
      if (search != "" && response.data.code == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true,
        });
      } else {
        store.dispatch("customer/fetchCustomerFilterDetails");
      }
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.search = search;
      routeTo.params.status = status;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      routeTo.params.custom = custom;
      next();
    });
}
export default {
  mixins: [notificationMixin, scrollTable, formatDate],
  props: {
    page: {
      type: Number,
      required: true,
    },
    show: {
      type: Number,
      required: true,
    },
    search: [String, Number],
    status: [String, Number],
    label: [String, Number],
    sort: [String, Number],
    custom: [String, Number],
  },
  name: "Customer",
  components: {
    LogRecord,
    RecordNotFound,
  },
  data() {
    return {
      arrow: false,
      export_data: [],
      export_modal: false,
      export_xl: {
        "Customer Type": "cus_type",
        "First Name": "cus_fname",
        "Last Name": "cus_lname",
        "Company Name": "cus_comp_name",
        "Customer ID": "cus_legacy_id",
        "Display Name": "cus_display_name",
        EmailID: "cus_mail",
        Phone: "cus_ph_no_1",
        Facebook: "cus_facebook_id",
        Twitter: "cus_twitter_id",
        Website: "cus_website",
        Notes: "cus_notes",
        "Currency Code": "cus_currency",
        "GST Treatment": "gst_type_name",
        "GST Identification Number (GSTIN)": "cus_gst_no",
        "PAN Number": "cus_pan_no",
        "Payment Terms": "cus_pymnt_term",
        "Billing Address line1": "billing_addr_line_1",
        "Billing Address line2": "billing_addr_line_2",
        "Billing City": "billing_city",
        "Billing State": "billing_state",
        "Billing Country": "billing_country",
        "Billing Pincode": "billing_pincode",
        "Shipping Address line1": "shipping_addr_line_1",
        "Shipping Address line2": "shipping_addr_line_2",
        "Shipping City": "shipping_city",
        "Shipping State": "shipping_state",
        "Shipping Country": "shipping_country",
        "Shipping Pincode": "shipping_pincode",
        // "Customer tags": "cus_tags",
        "Place of Supply": "place_of_supply",
        "Opening Balance": "opening_balance",
        "Exempt Reason": "exempt_reason",
        "Credit Limit": "credit_limit",
        "Created Time": "created_at",
        "Updated Time": "updated_at",
      },
      gst_type_name: "",
      logrecords: "",
      cus_gst_no: "",
      term_name: "",
      currency_name: "",
      place_of_supply: "",
      cus_legacy_id: "",
      modalPage: "",
      statusPage: "",
      CheckedCount: 0,
      CheckedCusIds: [],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      checkboxes1: [],
      showDismissibleAlert: this.$route.query.search == "" ? false : true,
      total: 10,
      check_index: [],
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      created_at: "",
      updated_at: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    store.state.customer.cus_index_history = from.fullPath;
    store.state.customer.index_status = from.params.status;
    next();
  },

  methods: {
    getrefreshList() {
      var page = this.page;
      var page_show = this.show;
      const currentPage = page;
      const show = page_show;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const update = this.$route.query.update;
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const update_status = update == true ? false : true;
      store
        .dispatch("customer/fetchLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom,
        })
        .then(() => {
          this.$router.push({
            name: this.$route.name,
            query: {
              page: currentPage,
              show: show,
              search: search,
              status: status,
              sort: sort,
              label: label,
              update: update_status,
            },
          });
        });
    },
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
    },

    async fetchExportData() {
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      const custom = this.$route.query.custom || "";
      const response = await store
        .dispatch("customer/fetchexportLists", {
          page: currentPage,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label,
          custom: custom,
        })
        .then(() => {
          if(this.status_code!=200){
             window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          }else{
          this.$root.$emit("bv::show::modal", "exportdata");
          return this.export;
          }
        });
      return response;
    },

    getPresentValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i]["filter_id"];
          break;
        }
      }
      return hasMatch;
    },
    handledelete() {
      this.submitted = true;
      var cus_ids = this.checkboxes1;
      cus_ids = cus_ids.filter((item) => item !== false && item !== true);
      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;
      const search = this.$route.query.search || "";
      const status = this.$route.query.status || "";
      const label = this.$route.query.label || "";
      const sort = this.$route.query.sort || "";
      var url, data;
      if (this.modalPage == "delete") {
        url = "custdelete";
        data = JSON.stringify({
          del_status: cus_ids,
        });
      } else if (this.modalPage == "status") {
        url = "custstatus";
        data = JSON.stringify({
          name: this.statusPage,
          status: cus_ids,
        });
      }

      store.dispatch("customer/" + url, data).then((response) => {
        this.submitted = false;
        this.CheckedCount = 0;
        this.checkboxes1 = [];

        store
          .dispatch("customer/fetchLists", {
            page: currentPage,
            show: show,
            search: search,
            status: status,
            sort: sort,
            label: label,
          })
          .then(() => {
            this.$route.params.page = currentPage;
            this.$route.params.show = show;
            this.$route.params.search = search;
            this.$route.params.status = status;
            this.$route.params.sort = sort;
            this.$route.params.label = label;
          })
          .then(async () => {
            this.page = await (this.lists.length == 0 && this.page != 1
              ? (this.page = 1)
              : this.page);
            this.show = show;
            this.status = status;
            this.label = label;
            this.$route.params.sort = sort;
            await this.$router.push({
              query: {
                page: this.page,
                show: this.show,
                search: search,
                status: this.status,
                sort: sort,
                label: this.label,
              },
            });
          });
        if (this.status_code == 200) {
          this.logrecords =
            this.message.message.length == 0
              ? this.message.success
              : this.message.message;
          this.$root.$emit("bv::show::modal", "loglist");
        } else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message.message,
            type: this.message.type,
            showCloseButton: true,
          });
        }
      });
    },
    //selectall the checkbox//
    checkAll(ev) {
      this.check_index = [];

      this.lists.map((value, index) => {
        this.checkboxes1[index + 1] =
          ev.target.checked == true ? value.cus_id : false;
      });

      this.CheckedCount =
        ev.target.checked == true
          ? (this.page - 1) * this.show + this.lists.length
          : 0;
    },
    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var cus_ids = this.checkboxes1;
      cus_ids = cus_ids.filter((item) => item !== false);
      // check all if page length matches
      if (cus_ids.length == this.lists.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }

      if (this[checkbox][id] != false) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    },
  },
  created() {
    var check = [false];
    var i;
    for (i = 0; i < this.total; i++) {
      check.push(false);
    }
    this.checkboxes1 = check;
    this.CheckedCount = 0;
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
    var temp = this;
    if (this.cus_settings_details.custom_field.length > 0) {
      this.cus_settings_details.custom_field.map(function (value) {
        temp.export_xl[value.label_name] = value.field_name;
      }, 0);
    }
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageCustomers(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store.state.customer.index_status = "";
    getPageCustomers(routeTo, next);
    this.CheckedCount = 0;
    this.checkboxes1 = [];
    this.check_index = [];
  },

  computed: {
    ...mapGetters(["token", "cus_settings_details"]),
    ...mapState({
      lists: (state) => state.customer.lists,
      total_count: (state) => state.customer.total_count,
      count: (state) => state.customer.count,
      search_criteria: (state) => state.customer.search_criteria,
      filter_list: (state) => state.customer.filter_list,
      filter_name: (state) => state.customer.filter_name,
      delete: (state) => state.customer.delete,
      export: (state) => state.customer.export,
      is_no_records: (state) => state.customer.is_no_records, // to check for an record in the database
      message: (state) => state.customer.log_details,
      code: (state) => state.customer.code, // to get status code
      status_code: (state) => state.customer.status_code,
      status_message: (state) => state.customer.status_message,
      status_type: (state) => state.customer.status_type,
    }),
  },
};
</script>



